<template>
  <ul class="menu-nav">
    <router-link
      v-if="false"
      to="/dashboard"
      v-slot="{ href, navigate, isActive, isExactActive }"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Dashboard</span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/products"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="checkPermission(['PRODUCT_VIEW', 'CATE_VIEW', 'PROPERTY_VIEW', 'PROVIDER_VIEW', 'BRAND_VIEW', 'PRODUCT_COMPONENT_CATE_VIEW', 'PRODUCT_COMPONENT_VIEW'])"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Danh mục</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/customers"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="checkPermission(['CUSTOMER_VIEW', 'POINT_VIEW', 'PROVIDER_VIEW', 'CUSTOMER_TYPE_VIEW'])"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">KH - NCC</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/inventory-receipt"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="
        checkPermission([
          'STOCK_VIEW',
          'STOCK_IMPORT_VIEW',
          'STOCK_EXPORT_VIEW',
          'STOCK_TRANSFER_REQUEST_VIEW',
          'STOCK_TRANSFER_VIEW',
          'STOCK_DEFECTIVE_IMPORT_VIEW',
          'STOCK_DEFECTIVE_EXPORT_VIEW',
          'STOCK_DEFECTIVE_RESTORATION_VIEW',
          'STOCK_LENDING_VIEW',
          'PO_VIEW',
          'STOCK_CHECK_VIEW',
          'IMEI_LIST_VIEW',
          'IMEI_HISTORY_VIEW',
          'STOCK_SLIP_REPORT_VIEW',
          'COST_RECALCULATION_VIEW',
          'COST_RECALCULATION_COMPUTE',
          'COST_RECALCULATION_APPLY',
          'OPENING_BALANCE_COST_VIEW',
          'OPENING_BALANCE_COST_EDIT',
        ])
      "
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Kho hàng</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/orders"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="checkPermissions(['ORDER_VIEW', 'ECOM_ORDER_VIEW', 'PRE_ORDER_VIEW', 'ORDER_SOURCE_VIEW'])"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Đơn hàng</span>
        </a>
      </li>
    </router-link>
    <router-link
      to="/bills"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="checkPermissions(['BILL_VIEW', 'BILL_DELIVERY_VIEW', 'BILL_WHOLESALE_VIEW', 'EINVOICE_VIEW', 'EINVOICE_ADJUSTMENT_VIEW'])"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Hóa đơn</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/warranty-receptions"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="checkPermission(['WARRANTY_RECEPTION_VIEW', 'WARRANTY_VIEW', 'WARRANTY_REPORT_VIEW', 'WARRANTY_REPORT_SUMMARY_VIEW', 'WARRANTY_REPORT_BY_EMPLOYEE_VIEW', 'WARRANTY_SOLUTION_CONFIG_VIEW', 'ERROR_LEVEL_VIEW', 'ERROR_GROUP_VIEW', 'WARRANTY_ERROR_CONFIG_VIEW', 'ACCOMPANYING_EQUIPMENT_VIEW', 'WARRANTY_SERVICE_VIEW'])"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Bảo hành</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/trade-in-programs"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="
        checkPermission('TRADE_IN_PROGRAM_VIEW') ||
        checkPermission('TRADE_IN_VIEW')
      "
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Thu cũ</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/accounting/accounts"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="checkPermission([
        'TRANSACTION_VIEW', 'ACCOUNTANT_VIEW', 'TRANSACTION_CATE_VIEW',
        'DEBT_PROVIDER_VIEW', 'DEBT_PROVIDER_DUE_DATE_VIEW',
        'INSTALLMENT_VIEW', 'DEBT_INSTALLMENT_BILL_VIEW', 'DEBT_INSTALLMENT_ORDER_VIEW',
        'DEBT_CREDIT_VIEW', 'DEBT_CREDIT_ORDER_VIEW',
        'DEBT_SHIP_FEE_ORDER_VIEW', 'DEBT_WARRANTY_INSTALLMENT_VIEW',
        'DISBURSEMENT_VIEW', 'DISBURSEMENT_CONFIG_VIEW', 'APPROVAL_VIEW',
      ])"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Kế toán</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/reports/sales-reports"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="checkPermission(['REPORT_TRANSACTION_STORE_VIEW', 'REPORT_TRANSACTION_STORE_EXPORT', 'RR_VIEW_ALL', 'CR_VIEW_ALL', 'INVENTORY_SUMMARY_REPORT_VIEW', 'PRODUCT_REVENUE_REPORT_VIEW', 'BILL_REVENUE_REPORT_VIEW', 'PRODUCT_IMEI_REVENUE_REPORT_VIEW', 'SALES_REPORT_VIEW'])"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Báo cáo</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/reward/reward-category"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="checkPermission(['REWARD_PRODUCT_CATEGORY_VIEW', 'REWARD_PROGRAM_VIEW', 'REWARD_DETAIL_VIEW', 'REWARD_CHECK_VIEW'])"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Hoa hồng</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/platform-integration"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="canSeePlatformIntegrationMenu"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Kênh bán</span>
        </a>
      </li>
    </router-link>

    <router-link
      to="/stores"
      v-slot="{ href, navigate, isActive, isExactActive }"
      v-if="checkPermissions(['STORE_VIEW', 'USER_VIEW', 'COMPANY_VIEW', 'TRANSFER_STORE_FORM_VIEW', 'EMPLOYEE_VIEW', 'ROLE_VIEW', 'VOUCHER_VIEW', 'PRO_ACCTACH_VIEW', 'PRO_PROMOTION_VIEW', 'WARRANTY_PACKAGE_VIEW', 'DISCOUNT_VIEW', 'FLEXIBLE_COMBO_VIEW', 'DEALSHEET_VIEW', 'APPROVAL_CONFIG_VIEW', 'SETTING_VIEW', 'IP_WHITELIST_VIEW', 'IP_BYPASS_VIEW'])"
    >
      <li
        aria-haspopup="true"
        data-menu-toggle="hover"
        class="menu-item"
        :class="[
          isActive && 'menu-item-active',
          isExactActive && 'menu-item-active',
        ]"
      >
        <a :href="href" class="menu-link" @click="navigate">
          <span class="menu-text">Cấu hình</span>
        </a>
      </li>
    </router-link>
  </ul>
</template>
<script>
import { mapGetters } from 'vuex';
import { SET_PERMISSION } from '@/core/services/store/modules/permission.module';
import ApiService from '@/core/services/api.service';
import permissionMixin from '@/view/mixins/permission.mixin';

export default {
  mixins: [permissionMixin],
  data() {
    return {};
  },
  name: 'KTMenu',
  mounted() {},
  computed: {
    ...mapGetters(['listPermission']),
    canSeePlatformIntegrationMenu() {
      return this.checkPermissions([
        'PLATFORM_INTEGRATION_VIEW',
        'PLATFORM_PRODUCT_MANAGE',
        'PLATFORM_ORDER_MANAGE',
        'PLATFORM_COMPLAINT_MANAGE',
        'PLATFORM_RECONCILIATION_MANAGE',
        'PLATFORM_PICK_LIST_REPORT_MANAGE',
        'PLATFORM_ORDER_REPORT_MANAGE',
        'PLATFORM_ORDER_FUNNEL_REPORT_MANAGE',
        'PLATFORM_BY_MARKETPLACE_REPORT_MANAGE',
        'PLATFORM_PROFIT_LOSS_REPORT_MANAGE',
        'PLATFORM_BY_PRODUCT_REPORT_MANAGE',
      ]);
    },
  },
  async created() {
    await this.getPermissions();
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route['path'].indexOf(match) !== -1;
    },
    async getPermissions() {
      await ApiService.get('permissions/').then((reponse) => {
        const permissions = reponse.data?.data || [];
        this.$store.dispatch(SET_PERMISSION, permissions);
      });
    },
  },
};
</script>
<style scoped lang="scss">
.quick-link::v-deep {
  .btn-sm,
  .btn-group-sm > .btn {
    padding: 0rem 0.3rem;
  }
  .btn.btn-secondary {
    background-color: transparent;
    border: none;
  }
  .dropdown-item {
    padding: 0.5rem 1.25rem;
  }
}
.font-style {
  font-size: 0.8rem;
}
</style>
